<template>
  <div>

      <iframe src="https://docs.google.com/document/d/e/2PACX-1vT5_Wii3rWhq-dAn-Z5Y19M4OrlGLsstW-AvCSJJkx1lwVBynrulW5xW7G7ab404KDT4kpQcsy1Uz_N/pub?embedded=true" width="100%" height="650px"></iframe>

  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>